import React, { FC } from 'react';
import { Form } from 'antd';
import { useFormContext, Controller } from 'react-hook-form';

import { IFormFieldWrapperProps } from './interfaces';

import './styles.scss';

const FormFieldWrapper: FC<IFormFieldWrapperProps> = ({
  name,
  label,
  required,
  render,
  help,
}) => {
  const {
    control,
    formState: { errors },
  } = useFormContext();

  const error = errors[name];

  return (
    <Form.Item
      help={(error && error['message']) || help}
      validateStatus={error ? 'error' : 'success'}
      label={label}
      className="form-field-wrapper"
      required={required}
    >
      <Controller
        name={name}
        control={control}
        render={({ field: { ref, ...props } }) => render(props)}
      />
    </Form.Item>
  );
};

export default FormFieldWrapper;
